import { useLocation } from "react-router-dom";
import Layout from "../layouts/layout";
import Items from "../containers/_memberships/items";
import Create from "../containers/_memberships/create";
import styles from "../styles/_screens/memberships.module.scss";

const Memberships = () => {
  const location = useLocation();
  const isNew = new URLSearchParams(location.search).get("new") === "1";

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.main}>
          {isNew ? <Create /> : <Items />}
        </div>
      </div>
    </Layout>
  );
};

export default Memberships;
